{
  "manager": {
    "exportModal": {
      "title": "Export Data",
      "largeDatasetNotice": "We've detected this is a large dataset. Please enter your email address below and we'll send you a link to download your data.",
      "emailLabel": "Email *",
      "emailDescription": "We will send you a link to download your data.",
      "emailPlaceholder": "Enter email"
    },
    "dailyReporting": {
      "pageTitle": "Daily Report",
      "dateLabel": "Date",
      "summary": "Summary",
      "headTitle": "Daily Reporting",
      "filterLabel": "Date: {date}"
    },
    "transactionList": {
      "title": "Transactions",
      "assignTags": "Assign Tags",
      "removeTags": "Remove Tags",
      "transactionDetails": "Transaction Details",
      "viewBooking": "View Booking",
      "viewInvoice": "View Invoice",
      "partiallyRefunded": "Partially Refunded",
      "fullyRefunded": "Fully Refunded",
      "amountRemaining": "({amount} remaining)",
      "totals": "Totals",
      "refund": "Refund",
      "invoice": "Invoice",
      "tagsLabel": "Tags",
      "assignTagsPlaceholder": "Search existing or type to create",
      "assignTagsInvalid": "Pick at least one tag to apply.",
      "removeTagsLabel": "Tags to remove",
      "removeTagsPlaceholder": "Pick tags to remove",
      "removeTagsInvalid": "Pick at least one tag to remove.",
      "showMore": "Show more",
      "showLess": "Show less",
      "headTitle": "Transaction List",
      "transactionsCount": "1 transaction | {count} transactions",
      "tagsCount": "1 tag | {count} tags",
      "assignTagsTitle": "Tag {transactions}",
      "assignTagsContext": "Tags will be added to {transactions}. Existing tags on those transactions are kept.",
      "applyingOkTitle": "Applying…",
      "applyOkTitle": "Apply",
      "applyTagsCount": "Apply 1 tag | Apply {count} tags",
      "selectAtLeastOneTag": "Please select at least one tag.",
      "tagsAssignedToast": "{tags} applied to {transactions}",
      "assignTagsError": "Failed to assign tags. Please try again.",
      "removeTagsTitle": "Remove tags from {transactions}",
      "removeTagsContext": "Pick which tags to strip from the selected {transactions}. Tags that aren’t on a given transaction are skipped.",
      "removingOkTitle": "Removing…",
      "removeOkTitle": "Remove",
      "removeTagsCount": "Remove 1 tag | Remove {count} tags",
      "tagsRemovedToast": "{tags} removed from {transactions}",
      "removeTagsError": "Failed to remove tags. Please try again.",
      "tagRemovedToast": "Removed \"{name}\"",
      "tagRemoveError": "Failed to remove \"{name}\". Please try again.",
      "invoicePrefix": "Invoice #{number}",
      "forMultipleBookings": "For multiple bookings",
      "bookingForDate": "Booking for {date}",
      "discountPercentOff": "{percent}% off",
      "discountAmountOff": "{amount} off",
      "typeBookingRefund": "Booking Refund",
      "typeBooking": "Booking",
      "refundSuccess": "Transaction refunded successfully",
      "refundError": "Failed to refund transaction"
    }
  }
}
